import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';

import {
  ChannelScope,
  ChannelWithDocId,
  OrganizationScope,
} from '@yoimo/client-sdk/channels';
import {
  BrandingOptions,
  BrandingService,
  ChannelCardComponent,
} from '@yoimo/joymo-ui';

import { Observable, catchError, map, of } from 'rxjs';

import { ScopeService } from '@core/services';
import { environment } from '@environment';

@Component({
  standalone: true,
  imports: [CommonModule, ChannelCardComponent],
  selector: 'joymo-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  host: {
    class: 'flex flex-column flex-justify-center h-100',
  },
})
export class NotFoundComponent {
  readonly channel$: Observable<ChannelWithDocId | undefined>;

  constructor(
    private scopeService: ScopeService,
    private brandingService: BrandingService
  ) {
    this.channel$ = this.scopeService.scope$.pipe(
      catchError((_err, _caught) => of(undefined)),
      map((scope) => {
        if (!scope) {
          this.applyBranding(environment.behavior.defaultTheme);
          return undefined;
        }
        const channel = this.scopeService.getChannelFromScope(scope);
        this.applyBranding(channel.branding);
        return channel;
      })
    );
  }

  private applyBranding(branding: BrandingOptions): void {
    this.brandingService.setTheme(branding, true);
  }
}
